import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import info from "../../assets/img/info.png";

function TooltipMessage(props) {
  const { msg } = props;
  return (
    <OverlayTrigger
      className="bg-light"
      overlay={<Tooltip id="tooltip-disabled">{msg}</Tooltip>}
    >
      <span className="d-inline-block">
        <span style={{ pointerEvents: "none" }}>
          <img
            src={info}
            alt="Jannu's health Food"
            className="ms-1"
            width="13px"
          />
        </span>
      </span>
    </OverlayTrigger>
  );
}

TooltipMessage.defaultProps = {
  msg: "*Resolution (449px * 250px)",
};

export default TooltipMessage;
